import { render, staticRenderFns } from "./FeedbackTextarea.vue?vue&type=template&id=1602ce8c&scoped=true&"
import script from "./FeedbackTextarea.vue?vue&type=script&lang=js&"
export * from "./FeedbackTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTextarea.vue?vue&type=style&index=0&id=1602ce8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1602ce8c",
  null
  
)

export default component.exports